import { MembershipSubscriptionMember } from '../models/membership-plan.model';
import { CreditcardFormModel } from '@frontend/unhideschool/shared/components/form-credit-card/form-credit-card.model';
import { UpgradeMembershipPlanPayloadModel } from '../ngxs/membership.model';

// PRO Accesses
export class MembershipMeAccessesFetch {
  static readonly type = '[MeAccesses API] Fetch';
}

// User Entitlement
export class MembershipUserEntitlementFetch {
  static readonly type = '[UserEntitlements API] Fetch';
  constructor(public uid: number) { }
}

// Subscription Payments
export class MembershipSubscriptionPaymentsFetch {
  static readonly type = '[SubscriptionPayments API] Fetch';
  constructor(public uid: number) { }
}

// Subscription Members
export class MembershipSubscriptionMembersFetch {
  static readonly type = '[SubscriptionMembers API] Fetch';
  constructor(public subscriptionid: number, public refresh = true) { }
}

// 'replace' swaps the member list for this page; 'append' merges the page
// into what's loaded (duplicates removed), for loading the rest in the
// background while the first page is already on screen.
export class MembershipSubscriptionMembersFetchPaginated {
  static readonly type = '[SubscriptionMembers API] Fetch Paginated';
  constructor(
    public subscriptionid: number,
    public page: number,
    public perpage: number,
    public mode: 'replace' | 'append' = 'replace'
  ) { }
}

export class MembershipSubscriptionMembersAdd {
  static readonly type = '[SubscriptionMembers UI/Effect] Add';
  constructor(public subscriptionid: number, public member: MembershipSubscriptionMember) { }
}

export class MembershipSubscriptionMembersRemove {
  static readonly type = '[SubscriptionMembers UI/Effect] Remove';
  constructor(
    public subscriptionmemberid: number,
    public subscriptionmemberstateid: number,
    public subscriptionmembertypeid: number
  ) { }
}

export class MembershipSubscriptionMembersUpdate {
  static readonly type = '[SubscriptionMembers UI/Effect] Update';
  constructor(public member: MembershipSubscriptionMember) { }
}

export interface MembershipSubscriptionMemberPatchData {
  fullname?: string;
  username?: string;
  alias?: string;
  careers?: Array<{ id: number; name: string }>;
  workspaceProgress?: number;
}

// Atualiza um único membro já carregado no state, sem request.
// Alimentado pelo retorno das mutations de UpdateUserProfile.
export class MembershipSubscriptionMemberPatch {
  static readonly type = '[SubscriptionMembers UI/Effect] Patch User';
  constructor(
    public uid: number,
    public changes: MembershipSubscriptionMemberPatchData
  ) { }
}

// Refetch de um membro só, para os campos derivados que a mutation não devolve
// (workspaceProgress depende dos cargos atribuídos).
export class MembershipSubscriptionMemberRefresh {
  static readonly type = '[SubscriptionMembers API] Refresh One';
  constructor(public subscriptionmemberid: number) { }
}

export class MembershipSubscriptionPaymentRetry {
  static readonly type = '[SubscriptionPayment UI/Effect] Retry';
  constructor(public subscriptionid: number, public gatewaytoken = null) { }
}

export class GetVindiGatewayToken {
  static readonly type = '[SubscriptionPayment UI/Effect] GetVindiToken';
  constructor(
    public formdata: CreditcardFormModel,
    public subscriptionid: number,
    public editprofile: boolean,
  ) { }
}

export class ChangeVindiGatewayProfile {
  static readonly type = '[SubscriptionPayment UI/Effect] ChangeVindiGatewayProfile';
  constructor(public subscriptionid: number, public gateway_token: string) { }
}



export class UpgradeMembershipPlan {
  static readonly type = '[MembershipState] Update Membership Plan';
  constructor(public newRootPlanId:number,
    public subscriptionId:number,
    public subscriptionPlanPriceId: number ) { }
}
